const sectionAAdjectives = [
    { key: "relaxed", label: "Relaxed" },
    { key: "tense", label: "Tense" },
    { key: "lively", label: "Lively" },
    { key: "withdrawn", label: "Withdrawn" },
    { key: "curious", label: "Curious" },
    { key: "at_ease", label: "At Ease" },
    { key: "fearful", label: "Fearful" },
    { key: "wary", label: "Wary" },
    { key: "content", label: "Content" },
    { key: "irritable", label: "Irritable" },
    { key: "frustrated", label: "Frustrated" },
    { key: "sociable", label: "Sociable" },
    { key: "indifferent", label: "Indifferent" },
    { key: "comfortable", label: "Comfortable" },
    { key: "calm", label: "Calm" },
    { key: "playful", label: "Playful" },
    { key: "agitated", label: "Agitated" },
    { key: "listless", label: "Listless" },
    { key: "anxious", label: "Anxious" },
    { key: "excited", label: "Excited" },
];

export { sectionAAdjectives };
